export default "__VITE_PUBLIC_ASSET__79e09b12__"